__turbopack_context__.v({
  "grid": "styles-module__eh3zXa__grid",
  "listDesktop": "styles-module__eh3zXa__listDesktop",
  "listMobile": "styles-module__eh3zXa__listMobile",
  "mobileFull": "styles-module__eh3zXa__mobileFull",
  "test": "styles-module__eh3zXa__test",
  "testA": "styles-module__eh3zXa__testA",
});
